// extracted by mini-css-extract-plugin
module.exports = {"sortIcon":"GridTheadSort_sortIcon___BbQR","sortIconSvg":"GridTheadSort_sortIconSvg__vlRX7","sortIconSvgActive":"GridTheadSort_sortIconSvgActive__rJ3dG"};